import { render } from "./ShoppingCartItem.vue?vue&type=template&id=36d6136a"
import script from "./ShoppingCartItem.vue?vue&type=script&lang=js"
export * from "./ShoppingCartItem.vue?vue&type=script&lang=js"

import "./ShoppingCartItem.vue?vue&type=style&index=0&id=36d6136a&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__